import { useEffect, useRef } from "react";
import { useSession } from "../../lib/auth";
import { identifyUser, resetUser } from "./posthog";

/**
 * Ties PostHog events to the signed-in account so a funnel can follow one
 * guest across devices and sessions. Only the opaque user id is sent — never
 * the email or name. On sign-out the identity is dropped so the next visitor
 * on a shared device is not stitched onto the previous account.
 *
 * `useSession` shares better-auth's cache with the header, so this adds no
 * request of its own.
 */
export function AnalyticsIdentity() {
  const { data: session } = useSession();
  const userId = session?.user?.id ?? null;
  const known = useRef<string | null>(null);

  useEffect(() => {
    if (userId) {
      if (known.current === userId) return;
      known.current = userId;
      identifyUser(userId);
      return;
    }
    if (known.current) {
      known.current = null;
      resetUser();
    }
  }, [userId]);

  return null;
}
